import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { ZonedDateTime } from '@js-joda/core';
/**
 * Configuration of the ability of court members to listen to court audio of the configured court system
 */
export class AudioPlaybackFeature {
    /**
     * @param id Identifies the feature
     * @param courtSystemId The court system of the feature
     * @param isEnabled Whether the feature is enabled
     * @param enabledOn The most recent time when this feature was enabled
     * @param status The status of the batch conversion of recordings for the court system that is triggered when this
     * feature is enabled
     * @param configuration Configuration of an enabled audio playback feature
     */
    constructor(id, courtSystemId, isEnabled, enabledOn, status, configuration) {
        this.id = id;
        this.courtSystemId = courtSystemId;
        this.isEnabled = isEnabled;
        this.status = status;
        this.configuration = configuration;
        this.enabledOn = enabledOn;
    }
}
__decorate([
    Serialize(() => ZonedDateTime),
    __metadata("design:type", Object)
], AudioPlaybackFeature.prototype, "enabledOn", void 0);
